import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]
  
  connect() {
    console.log("Accordion controller connected")
  }
  
  toggle(event) {
    event.preventDefault()
    
    const target = event.currentTarget.dataset.target
    const contentElement = this.element.querySelector(`[data-content="${target}"]`)
    const iconElement = event.currentTarget.querySelector('[data-accordion-target="icon"]')
    
    if (!contentElement) return
    
    // Close all other accordions in this container
    this.closeAllExcept(target)
    
    // Toggle the clicked accordion
    const isHidden = contentElement.classList.contains('hidden')
    
    if (isHidden) {
      this.openAccordion(contentElement, iconElement)
    } else {
      this.closeAccordion(contentElement, iconElement)
    }
  }
  
  openAccordion(contentElement, iconElement) {
    // Remove hidden first to measure height
    contentElement.classList.remove('hidden')
    
    // Set initial state - collapsed
    contentElement.style.height = '0px'
    contentElement.style.overflow = 'hidden'
    contentElement.style.transition = 'height 0.3s ease-out'
    
    // Get the natural height
    const naturalHeight = contentElement.scrollHeight + 'px'
    
    // Animate to natural height
    requestAnimationFrame(() => {
      contentElement.style.height = naturalHeight
    })
    
    // Clean up after animation
    setTimeout(() => {
      contentElement.style.height = 'auto'
      contentElement.style.overflow = 'visible'
    }, 300)
    
    // Rotate chevron
    if (iconElement) {
      iconElement.style.transition = 'transform 0.3s ease-out'  
      iconElement.style.transform = 'rotate(180deg)'
    }
  }
  
  closeAccordion(contentElement, iconElement) {
    // Set current height explicitly first
    const currentHeight = contentElement.scrollHeight + 'px'
    contentElement.style.height = currentHeight
    contentElement.style.overflow = 'hidden'
    contentElement.style.transition = 'height 0.3s ease-out'
    
    // Force reflow
    contentElement.offsetHeight
    
    // Animate to 0 height
    requestAnimationFrame(() => {
      contentElement.style.height = '0px'
    })
    
    // Hide after animation
    setTimeout(() => {
      contentElement.classList.add('hidden')
      contentElement.style.height = ''
      contentElement.style.overflow = ''
      contentElement.style.transition = ''
    }, 300)
    
    // Reset chevron
    if (iconElement) {
      iconElement.style.transition = 'transform 0.3s ease-out'
      iconElement.style.transform = 'rotate(0deg)'
    }
  }
  
  closeAllExcept(exceptTarget) {
    const allContent = this.element.querySelectorAll('[data-accordion-target="content"]')
    
    allContent.forEach((contentElement) => {
      const target = contentElement.dataset.content
      if (target !== exceptTarget && !contentElement.classList.contains('hidden')) {
        const button = this.element.querySelector(`[data-target="${target}"]`)
        const iconElement = button ? button.querySelector('[data-accordion-target="icon"]') : null
        this.closeAccordion(contentElement, iconElement)
      }
    })
  }
}